import React from "react";

const CardCatalogoBiblio = ({titulo, resumen}) => (

    <div>
        <h3 className="h5 mb-2">{titulo}</h3>
        <p className="mb-0">
            <span className="text-muted">Resumen</span>
            <br></br>
            {resumen}
        </p>
    </div>
);

export default CardCatalogoBiblio;
